export enum AvailableLanguageKeys {
    EN = "en",
    DE = "de",
}
